export const getTabWidths = ($tabParentContainer) => {
  const elements = Array.from($tabParentContainer.children);
  const widths = elements.map((el) => el.getBoundingClientRect().width);

  const totalElementWidth = widths.reduce((sum, w) => sum + w, 0);
  const moreButtonWidth = widths.length
    ? widths[widths.length - 1]
    : 0;

  return { widths, totalElementWidth, moreButtonWidth };
};

export const getNumberOfVisibleTabs = ({
  tabContainer,
  widths,
  totalElementWidth,
  moreButtonWidth,
}) => {
  let buffer = 30;

  if (typeof getComputedStyle === 'function') {
    const style = getComputedStyle(tabContainer);
    const parse = (prop) => Number.parseInt(style[prop], 10) || 0;

    buffer = parse('paddingLeft')
      + parse('paddingRight')
      + parse('marginLeft')
      + parse('marginRight')
      + parse('borderLeftWidth')
      + parse('borderRightWidth');
  }

  // Tends to overflow into the header padding which causes it to recalculate when the dropdown is open. Add 25 px to the buffer, just to be safe.
  const allowedWidth = tabContainer.getBoundingClientRect().width - (buffer + 25) - 15;

  if (allowedWidth >= totalElementWidth) {
    return widths.length;
  }

  const availableForTabs = allowedWidth - moreButtonWidth;
  let used = 0;

  // console.log('availableForTabs', availableForTabs);
  for (let i = 0; i < widths.length; i += 1) {
    // console.log('used', used);
    if (used + widths[i] <= availableForTabs) {
      used += widths[i];
    } else {
      return i;
    }
  }

  return widths.length;
};
